import isoLanguage from './ISO-639-1-language.json';

export type IsoLanguage = {
  name: string;
  code: string;
};
export const isoLanguages: IsoLanguage[] = isoLanguage;
